/**
 * 头部
 */
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import cls from 'classnames';

import styles from './index.module.scss';

interface IProps {
  title: string | React.ReactNode;
  onClose: () => void;
}

const Index: React.FC<IProps> = ({ title, onClose }) => {
  return (
    <div className={cls(styles.headerContainer, 'drawer-header-container')}>
      <div className={cls(styles.headerTitle, 'drawer-main-title')}>{title}</div>
      <span className={cls(styles.headerIcon, 'drawer-close-icon')} onClick={onClose}>
        <CloseOutlined />
      </span>
    </div>
  );
};

export default Index;
